<table class="project project_isEmpty">
    <thead class="project-hd">
        <tr class="project-hd-accentRow">
            <th>Shopping Cart</th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
        </tr>
    </thead>
    <tbody class="project-bd">
        <td colspan="5" class="vr" >
            <h2 class="hdg hdg_2">Your cart is empty</h2>
            <div><a href="/shop/all" class="btn">Shop All Products</a></div>
        </td>
    </tbody>
</table>
{{> savedForLater}}
